import React from "react";

/** Lightweight SVG Bar Chart (no external chart libs) */
export default function MiniBarChart({ data = [], height = 220, barGap = 12, barRadius = 6 }) {
  // data: [{ name: "Received", count: 12 }, ...]
  const padding = { top: 10, right: 10, bottom: 28, left: 10 };
  const width = 520;
  const innerW = width - padding.left - padding.right;
  const innerH = height - padding.top - padding.bottom;
  const max = Math.max(1, ...data.map(d => Number(d.count || 0)));
  const barW = data.length > 0 ? (innerW - (data.length - 1) * barGap) / data.length : 0;
  const scaleY = (v) => innerH - (Number(v) / max) * innerH;

  return (
    <div className="w-full overflow-x-auto">
      <svg width={width} height={height} className="min-w-[520px]">
        {[0, 0.25, 0.5, 0.75, 1].map((p, idx) => {
          const y = padding.top + innerH * p;
          return <line key={idx} x1={padding.left} x2={padding.left + innerW} y1={y} y2={y} stroke="#e5e7eb" strokeDasharray="3 3" />;
        })}
        {data.map((d, i) => {
          const h = innerH - scaleY(d.count);
          const x = padding.left + i * (barW + barGap);
          const y = padding.top + scaleY(d.count);
          return (
            <g key={d.name + i}>
              <rect x={x} y={y} width={barW} height={h} rx={barRadius} fill="#10b981" opacity="0.9" />
              <text x={x + barW / 2} y={y - 6} textAnchor="middle" fontSize="10" fill="#374151">
                {new Intl.NumberFormat("en-IN").format(Number(d.count || 0))}
              </text>
              <text x={x + barW / 2} y={height - 8} textAnchor="middle" fontSize="11" fill="#6b7280">
                {d.name}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
}
